export const EXPLORE_SORT_OPTIONS = [
  { value: 'newestFirst', label: 'Newest First' },
  { value: 'cheapFirst', label: 'Cheap First' },
  { value: 'expensiveFirst', label: 'Expensive First' },
]
